/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Nexy_Feature_2_DescInputs */

const es_home_nexy_feature_2_desc = /** @type {(inputs: Home_Nexy_Feature_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta información de correos, archivos y eventos en una respuesta unificada.`)
};

const en_home_nexy_feature_2_desc = /** @type {(inputs: Home_Nexy_Feature_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect information from emails, files, and events into a unified answer.`)
};

/**
* | output |
* | --- |
* | "Connect information from emails, files, and events into a unified answer." |
*
* @param {Home_Nexy_Feature_2_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_nexy_feature_2_desc = /** @type {((inputs?: Home_Nexy_Feature_2_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Nexy_Feature_2_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_nexy_feature_2_desc(inputs)
	return en_home_nexy_feature_2_desc(inputs)
});
export { home_nexy_feature_2_desc as "home.nexy.feature_2_desc" }